// Busca de veículo única pra tela Veículos e a lista do mapa (pedido
// 2026-10-01): placa, nome, IMEI, número da linha, ICCID, chassi, motorista
// e nome/e-mail/CPF-CNPJ/razão social do cliente vinculado.
//
// Compara de dois jeitos: texto sem acento/maiúscula ("joao" acha "João") e
// só dígitos/letras, pra formatação não atrapalhar ("qhv2337" acha
// "QHV-2337", "54 99100-0204" acha "5499100204", CPF com ou sem pontos).
import type { Vehicle } from "@/types";
import type { VehicleSearchEntry } from "@/services/vehicle-metadata.service";

function normalize(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

function compact(value: string): string {
  return normalize(value).replace(/[^a-z0-9]/g, "");
}

export interface VehicleHaystack {
  text: string;
  compact: string;
}

// Pré-calculado uma vez por veículo (useMemo de quem usa), nunca a cada
// tecla — a frota pode ter milhares de veículos.
export function vehicleSearchHaystack(v: Vehicle, entry?: VehicleSearchEntry): VehicleHaystack {
  const parts: (string | null | undefined)[] = [
    v.name,
    v.plate,
    v.driver,
    v.id,
    v.imei,
    v.phone,
    entry?.simNumber,
    entry?.simIccid,
    entry?.chassis,
  ];
  for (const c of entry?.clients ?? []) {
    parts.push(c.name, c.email, c.cpfCnpj, c.companyName);
  }
  const fields = parts.filter((p): p is string => !!p);
  return {
    text: fields.map(normalize).join(" | "),
    // "|" separa os campos pra um termo não "emendar" o fim de um campo
    // com o começo do outro.
    compact: fields.map(compact).join("|"),
  };
}

export function matchesVehicleSearch(haystack: VehicleHaystack, query: string): boolean {
  const q = normalize(query.trim());
  if (!q) return true;
  if (haystack.text.includes(q)) return true;
  const qc = compact(q);
  return qc.length > 0 && haystack.compact.includes(qc);
}
